import { CONFIG } from '../core/config';
import { ViewModel } from './view-model';

export class PerformanceStandardRequirement implements ViewModel {
  readonly friendlyTypeNameSingular = 'Performance Standard Requirement';
  readonly apiRoute: string = CONFIG.apiRoutes.performanceStandardRequirement;

  public id: string;
  public reference: string;
  public type: RequirementType;
  public displayType: string;
  public percentage: string;
  public requirement: string;
  public performanceStandardId: string;
  public rowNumber: number

  json(): any {
    return this;
  }

  loadFromJson(data) {
    this.id = data.id;
    this.reference = data.reference;
    this.type = data.type;
    this.displayType = RequirementType[data.type]; 
    this.percentage = data.percentage;
    this.requirement = data.requirement;
    this.performanceStandardId = data.performanceStandardId;
    this.rowNumber = data.rowNumber;
  }
}

export enum RequirementType {
  Functionality = 0,
  Availability = 1,
  Reliability = 2,
  Survivability = 3
}
